import type { SurveyElementJson } from '@coorum-research/shared-common/types'

type Props = {
  currentElement: SurveyElementJson
}

export function ElementHeader({ currentElement }: Props) {
  return (
    <div className="pb-3 font-survey">
      <h5 className="text-[20px] font-semibold text-[var(--theme-title-color)]">
        <span className="">
          {currentElement.title || currentElement.name}
        </span>
        {currentElement.isRequired && (
          <>
            <span
              className="ml-1 text-red-500"
              aria-hidden="true"
            >
              *
            </span>
          </>
        )}
      </h5>
      {(currentElement.description != null) && (
        <div className="text-pretty pt-2 text-black/45">
          {currentElement.description}
        </div>
      )}
    </div>
  )
}
